import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'One-Fifth Calculator - Calculate One-Fifth Based on the Total Amount';
const DESCRIPTION = 'The One-Fifth Calculator calculates one-fifth based on the entered total amount.';
const KEYWORDS = 'One-Fifth, Calculate One-Fifth, One-Fifth Calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/one-fifth';
function Calculator() {
    const [totalAmount, setTotalAmount] = useState('');
    const [oneFifthAmount, setOneFifthAmount] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!totalAmount) {
            setError('Please enter the total amount');
            setOneFifthAmount('');
            return;
        }
        const amountValue = parseFloat(totalAmount);
        if (isNaN(amountValue) || amountValue <= 0) {
            setError('Please enter a valid and positive value for the total amount');
            setOneFifthAmount('');
            return;
        }
        const oneFifth = amountValue / 5;
        setOneFifthAmount(oneFifth.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <h2 style={{ fontSize: '18px' }}>How to Calculate One-Fifth</h2>
                                        <p>
                                            To calculate one-fifth, you need to enter the total amount you want to calculate one-fifth of.
                                            Then, one-fifth is calculated simply by dividing the total amount by the number 5.
                                        </p>
                                        <p>
                                            One-Fifth = Total Amount / 5
                                        </p>
                                        <p>
                                            You can use this calculator to calculate one-fifth based on the entered total amount.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label htmlFor="amoutNumber" className="form-label ms-2">Total Amount</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Total Amount"
                                                        value={totalAmount}
                                                        onChange={(e) => setTotalAmount(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate One-Fifth
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {oneFifthAmount !== '' && (
                                                            <p className='p-3 mb-2 bg-success text-white'>
                                                                One-Fifth: {oneFifthAmount}
                                                            </p>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.mathCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <br />
        </div>
    );
}
export default Calculator;
